import { createContext } from 'react';
export const AccountRecoveryEmailContext = createContext(null);
